import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { EDeductionType } from "@zeal/common";

export interface IContractorDeductionTemplate {
  companyID: string;
  deductionTemplateID: string;
  contractorID: string;
  agency_address?: string;
  agency_name?: string;
  case_id?: string;
  custom_name?: string;
  deduction_credit: boolean;
  deduction_type: string;
  effective_end_date?: string;
  effective_start_date: string;
  contractor_contribution_amount?: number;
  contractor_contribution_percentage?: number;
  external_id?: string;
  hsa_type?: string;
  order_number?: string;
  document?: string;
  zeal_managed?: boolean;
}

export const getContractorDeductionTemplates = (axios: IAxiosInstance) => {
  return async (params: {
    companyID: string;
    contractorID?: string;
    deduction_type?:
      | typeof EDeductionType.GARNISHMENT
      | typeof EDeductionType.MISCELLANEOUS;
  }): Promise<IContractorDeductionTemplate[]> => {
    const response = await axios.noRetry.get<
      IApiResponse<IContractorDeductionTemplate[]>
    >(`/api/contractor-deduction-templates`, {
      params,
    });
    const data = response.data;

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to fetch contractor deduction templates");
  };
};
